{
  "LOGIN": {
        "SSO-BUTTON": "Přihlásit se přes SSO",
    "APP-NAME": "Platform {{ appName }}",
    "TITLE": "Přihlaste se do editoru workflow ",
    "ACCOUNT-PLACEHOLDER": "Jméno účtu",
    "ACCOUNT-REQUIRED": "Název účtu je povinný.",
    "ACCOUNT-SHORT": "Název účtu musí obsahovat alespoň 2 znaky.",
    "USERNAME-PLACEHOLDER": "Uživatelské jméno",
    "USERNAME-REQUIRED": "Uživatelské jméno je povinné",
    "USERNAME-SHORT": "Uživatelské jméno musí obsahovat alespoň 2 znaky.",
    "PASSWORD-PLACEHOLDER": "Heslo",
    "PASSWORD-REQUIRED": "Je vyžadováno heslo.",
    "PASSWORD-SHORT": "Heslo musí obsahovat alespoň 6 znaků.",
    "REMEMBER-ACCOUNT-NAME": "Pamatovat název účtu",
    "FORGOT-PASSWORD": "ZAPOMNĚLI JSTE HESLO?",
    "LOGIN-BUTTON": "PŘIHLÁSIT SE",
    "BACK": "ZPĚT",
    "VERIFICATION-CODE": "Ověřovací kód",
    "VERIFICATION-SENDED": "Poslali jsme vám e-mail s ověřovacím kódem.",
    "VERIFY-BUTTON": "OVĚŘIT",
    "TERMS": "Podmínky služby",
    "PRIVACY": "Zásady ochrany osobních údajů",
    "NO-INTERNET-ERROR": "Žádný internet. Zkontrolujte prosím své internetové připojení.",
    "USERNAME-PASSWORD-ERROR": "Nesprávné uživatelské jméno nebo heslo",
    "INVALID-VERIFICATION-CODE": "Neplatný dvoufázový ověřovací kód.",
    "ACCOUNT-DISABLED": "Platnost vašeho účtu vypršela. Kontaktujte prosím {{ contactMail }}",
    "NO-WORKFLOW-LICENSE": "[object Object]",
    "UNKNOWN-ERROR": "Při přihlašování došlo k chybě.",
    "LINK-ID-MISSING": "Chybí ID odkazu",
    "INTERNAL-ERROR": "Neznámá chyba",
    "ID-OR-NAME-MISSING": "Chybí ID nebo název odkazu",
    "GUEST-PASSWORD-WRONG": "Heslo pracovního postupu je špatné"
  },
  "MAIN": {
    "CONTENT": {
      "DASHBOARD": {
        "NO-WORKFLOW-FOR-NORMAL-USERS": "Prázdný seznam",
        "NO-WORKFLOW": {
          "TITLE": "Workflow",
          "TEXT": "Chtěli byste vědět, jak si zjednodušit pracovní procesy, eliminovat papírování a snížit administrativní zátěž? Naše softwarové řešení je jednotné, jediné softwarové řešení pro řízení pracovních procesů, které sníží složitost řízení lidských zdrojů a pracovních procesů. Toto softwarové řešení lze přizpůsobit vašim specifickým potřebám a jedná se o škálovatelnou technologii.",
          "CREATE": "Vytvořit workflow"
        },
        "AI-IN-PROGRESS": "AI probíhá...",
        "TITLE": "Workflows",
        "CREATE": "VYTVOŘIT WORKFLOW",
        "GENERATE": "VYTVOŘTE AUTOMATICKÝ WORKFLOW POMOCÍ AI",
        "WORKFLOW-TABLE": {
          "NAME": "název",
          "CREATED-BY": "Vytvořeno",
          "STATUS": {
            "TITLE": "Stav",
            "PUBLISHED": "Publikováno",
            "DRAFT": "Návrh",
            "INCOMPLETE": "Neúplný"
          },
          "ACTIONS": {
            "TITLE": "Akce",
            "OPTIONS": {
              "TITLE": "Možnosti",
              "EDIT": "Upravit koncept",
              "USERS": "Uživatelé",
              "PUBLISH": "Publikovat koncept",
              "PUBLISH-VIEW": "Zobrazit Publikováno",
              "DUPLICATE": "Duplikovat workflow",
              "DELETE": "Smazat pracovní postup",
              "MOVE-TO-FOLDER": "Přesunout do složky"
            },
            "PREFILLED-OPTIONS": {
              "EDIT": "Upravit",
              "SHOW-QR": "Zobrazit QR",
              "DUPLICATE": "Duplikát",
              "DELETE": "Vymazat"
          },
          "SUBMITTED-OPTIONS": {
            "SHOW-REPORT": "Zobrazit hlášení",
            "CHANGE-PREFILLED": "Změnit na předvyplněné"
        }
          },
          "START": "START",
          "LAST-EDITED": "Naposledy upraveno",
          "PUBLISHED-AT": "Publikováno na",
          "LANGUAGES": "Jazyky",
          "CONTENT-LANGUAGE": "JAZYK OBSAHU",
          "FILTER": {
            "FILTER-BY": "Filtrovat podle",
            "SELECT-LABEL": "Vyberte štítek",
            "SELECTED-LABELS": "Vybrané štítky"
          },
          "MANAGE-WORKFLOWS": "Spravujte pracovní postupy"
        },
        "FOLDER": {
          "MOVE-TO-FOLDER": "Přesunout do složky",
          "SELECTED": "vybraný",
          "CREATE-FOLDER": "VYTVOŘIT NOVOU SLOŽKU",
          "NOT-FOLDERED": "Není ve složce",
          "DELETE-FOLDER": "Smazat složku",
          "NO-WORKFLOW-FOUND": "Nebyly nalezeny žádné pracovní postupy.",
          "EDIT-FOLDER": "Upravit složku",
          "MOVE-TO": "Přesunout do",
          "FOLDER-NAME": "Název složky",
          "CREATE": "Vytvořit",
          "FOLDERS": "Složky",
          "FOLDER-NAME-UNIQUE-ERROR": "Název složky musí být jedinečný",
          "DELETE-FOLDER-WARNING-TEXT": "Opravdu chcete smazat složku?",
          "DELETE-FOLDER-INFO-TEXT": "Odstraněním této složky nedojde k odstranění jejích obsažených pracovních postupů; budou přesunuty do 'Není ve složce'."
      },
        "SEARCH": {
          "TITLE": "Pokročilé vyhledávání",
          "PLACEHOLDER": "Zadejte vyhledávací dotaz...",
          "BUTTON": "Hledat",
          "CANCEL": "Zrušit",
          "CLEAR": "Vymazat vyhledávání",
          "RESULTS": "Výsledky vyhledávání",
          "NO_RESULTS": "Pro váš vyhledávací dotaz nebyly nalezeny žádné pracovní postupy.",
          "ERROR": "Vyhledávání selhalo. Zkuste to prosím znovu.",
          "APPLIED": "Vyhledávání použito"
        },
        "TEXT-MESSAGE": "Vaše změny budou odstraněny. Chcete smazat tento workflow, který jste přidali dříve?",
        "TEXT-MESSAGE-PUBLISH-VIEW": "Přepnete se do režimu úprav. Na posledním aktualizovaném konceptu můžete provádět změny.",
        "TEXT-MESSAGE-UNSAVED-CHANGES": "Existují neuložené změny. Budou uloženy a publikovány.",
        "TEXT-MESSAGE-CLOSE-WORKFLOW": "Opravdu chcete tento workflow zavřít? Vaše změny budou odstraněny.",
        "TEXT-MESSAGE-CONDITIONAL-WORKFLOW": "Workflow, který se pokoušíte otevřít, je podmíněný pracovní postup. Naše webová verze to zatím nepodporuje.",
        "CANCEL": "ZRUŠIT",
        "CLOSE": "ZAVŘÍT",
        "EXPORT-WORKFLOWS": "EXPORTOVAT WORKFLOW",
        "SAVE-AS-DRAFT": "Uložit jako koncept",
        "CONTINUE": "Pokračovat",
        "UPDATE": "Aktualizace",
        "CONTINUE-UPPERCASE": "POKRAČOVAT",
        "START-OVER": "ZAČÍT ZNOVU",
        "WORKFLOW-STARTED": "Tento pracovní postup jste již zahájili. Chcete pokračovat, nebo začít nový?",
        "NEW-VERSION": "Tento pracovní postup nelze otevřít. Musíte publikovat novou verzi Workflow",
        "ANOTHER-COPY": "Kopie tohoto pracovního postupu se vytvoří jako verze 1 ve stavu konceptu s příponou \"(Copy)\" v názvu. Zkopírují se také všechny jeho kroky, pole a soubory.",
        "DUPLICATE-SUCCESSFUL": "Workflow byl úspěšně zkopírován.",
        "DUPLICATE-NESTED-SKIPPED": "Odkazy na vnořené workflow nebyly zkopírovány.",
        "DUPLICATE-FILES-FAILED": "Nepodařilo se zkopírovat {{count}} soubor(ů). Kopie stále odkazuje na původní soubory.",
        "DUPLICATE-PARTIAL": "Kopie byla vytvořena, ale kopírování souborů nebylo dokončeno. Otevřete kopii a zkontrolujte média.",
        "DUPLICATE-ERROR": "Tento workflow nelze zkopírovat.",
        "DELETE-SUCCESSFUL": "Operace odstranění byla úspěšná",
        "DELETE-ERROR": "Chyba odstranění",
        "WORKFLOW-NOT-FOUND": "Pracovní postup nebyl nalezen",
        "CREATION-LIMIT": "Bylo dosaženo limitu vytváření pracovního postupu",
        "PUBLISH-SUCCESSFUL": "Publikování je úspěšné",
        "PUBLISH-ERROR": "Chyba publikování",
        "EXPORT-CANCELED": "Export zrušen",
        "EXPORT-FOLDER": "Složka exportu existuje",
        "EXPORT-SUCCESSFUL": "Export je úspěšný",
        "YES": "ANO",
        "DELETE-REPORT-TITLE": "Smazat zprávu",
        "DELETE-REPORT-TEXT": "Opravdu chcete tento přehled smazat?",
        "CONNECTED-WORKFLOW-WARNING-TEXT": "Tento pracovní postup nelze odstranit, protože je připojen k jinému pracovnímu postupu. Nejprve jej musíte odebrat z připojeného pracovního postupu.",
        "SUBMITTED-REPORT-TO-PREFILLED-TEXT": "Opravdu chcete tento přehled změnit jako předvyplněný?",
        "SUBMITTED-REPORT-TO-PREFILLED-TITLE": "Změnit stav zprávy",
        "NESTED-WORKFLOWS-CONNECTION-ENABLE-WARNING": "V pracovním postupu, který jste přidali, je spojení. Proto bude připojení aktivováno ve vašem aktuálním pracovním postupu. Po uložení pracovního postupu zkontrolujte stránku připojení."
      },
      "REMOTE": {
        "IMAGE-COLLABORATION": {
          "UNDO": "vrátit",
          "REDO": "Znovu",
          "ANNOTATE": "Přidat poznámku",
          "REVERT": "Vrátit zpět",
          "ZOOM-IN": "Přiblížit",
          "ZOOM-OUT": "Oddálit",
          "UP": "Nahoru",
          "DOWN": "Dolů",
          "LEFT": "Vlevo",
          "RIGHT": "Vpravo"
        }
      },
      "REPORT": {
        "NAME": "Název",
        "DESCRIPTION": "Popis",
        "STEPS-COMPLETED": "Kroky dokončeny",
        "START": "Začátek v",
        "END": "Konec v",
        "DURATION": "Doba trvání",
        "EXPORT": "Export as CSV",
        "SUBMITTED-BY": "Předloženo",
        "STEP-LIST": {
          "NAME": "Název úkolu",
          "CONTENT": "Obsah",
          "DURATION": "Doba trvání",
          "NO-CONTENT": "N/A",
          "DETECTED": "Zjištěno",
          "NOT-DETECTED": "Nezjištěno",
          "MATCHED": "Shoda",
          "NOT-MATCHED": "Žádná shoda",
          "ENTERED-VALUE": "Zadaná hodnota",
          "SCANNED-VALUE": "Naskenovaná hodnota"
        },
        "FILES": "Soubory",
        "OPTIONS": "Možnosti",
        "APPROVAL": {
          "TITLE": "Odsouhlasení",
          "DESCRIPTION-TEXT": "Chcete-li tuto zprávu schválit, podepište se prosím níže.",
          "SIGN": "PODEPSAT",
          "RESEND": "Znovu odeslat žádost o schválení",
          "NOT-SIGNED": "NEPOPISENO",
          "DELETE-APPROVAL": "Jste si jistí, že to chcete smazat?",
          "DELETE": "Vymazat"
        },
        "SELECT-LANGUAGE": "Zvolte jazyk",
        "MISSING-PARAMETERS": "Chybí parametry",
        "INVALID-TOKEN": "Neplatný token",
        "REPORT-NOT-FOUND": "Zpráva nebyla nalezena",
        "SUCCESSFULLY-SENDED": "Úspěšně odesláno",
        "REMOTE-CALL": {
          "TITLE": "Remote hovory",
          "STATUS": "Stav",
          "STEP": "Krok",
          "USERS": "Uživatelé",
          "GUEST": "Host",
          "CALL-FAILED": "Hovor nebyl zahájen",
          "CREATED-AT": "Vytvořeno v"
      }
      },
      "REPORT-LIST": {
        "NO-REPORT": {
          "TITLE": "Hlášení o Workflow",
          "TEXT": "Neexistuje žádné hlášení.",
          "NO-REPORT-FOUND": "Nebyl nalezen žádný přehled spojený s daným ID odkazu"
        },
        "TITLE": "Hlášení",
        "PLACEHOLDER": "Hledat podle jména",
        "LIST": {
          "WORKFLOW": "Workflow",
          "VERSION": "Verze",
          "SUBMITTED-BY": "Předloženo",
          "SUBMITTED-TITLE": "Odesláno",
          "SUBMITTED": "Odesláno"
        },
        "LAST-SAVED": "Naposledy uloženo",
        "PERMISSION-ERROR": "K zobrazení hlášení nemáte oprávnění",
        "ERROR": "CHYBA",
        "IMPORT-CANCELED": "Import zrušen",
        "REPORT-FORMAT-WRONG": "Formát zprávy je nesprávný",
        "IMPORT-SUCCESSFUL": "Import byl úspěšný",
        "FILTER-ID": "Vyhledávání podle ID značky",
        "ID-TAG": "Tag-ID"
      },
      "USER-DETAIL": {
        "CREATE_TITLE": "Vytvořit uživatele",
        "EDIT_TITLE": "Upravit uživatele",
        "EDIT_DETAILS": "Upravit detaily uživatele",
        "NAME": "název",
        "NAME_REQUIRED": "Jméno je povinné.",
        "NAME_PATTERN": "Název může obsahovat pouze písmena, čísla, podtržítka ( _ ) a spojovníky ( - ).",
        "USERNAME": "Uživatelské jméno",
        "USERNAME_REQUIRED": "Uživatelské jméno je povinné.",
        "USERNAME_PATTERN": "Uživatelské jméno může obsahovat pouze písmena, čísla, podtržítka ( _ ) a spojovníky ( - ).",
        "USERNAME_EXISTS": "Uživatelské jméno již existuje",
        "EMAIL": "E-mail",
        "EMAIL_REQUIRED": "E-mail je povinné.",
        "INVALID_EMAIL": "Neplatný formát e-mailu.",
        "SAVE_CHANGES": "ULOŽIT ZMĚNY",
        "DELETE_USER": "ODSTRANIT UŽIVATELE",
        "CHANGE_PASSWORD": "Změnit heslo",
        "CREATE_PASSWORD": "Vytvořit heslo",
        "NEW_PASSWORD": "nové heslo",
        "CONFIRM_NEW_PASSWORD": "Potvrďte nové heslo",
        "SUBMIT_NEW_PASSWORD": "ZMĚNIT HESLO",
        "PASSWORD_REQUIRED": "Je vyžadováno heslo.",
        "PASSWORD_REQUIREMENTS": "Heslo nesplňuje níže uvedené požadavky.",
        "CONFIRM_PASSWORD": "Potvrďte heslo",
        "CONFIRM_REQUIRED": "Je vyžadováno potvrzení hesla.",
        "PASSWORD_MATCH": "Hesla se neshodují.",
        "PASSWORD_MUST": "Heslo musí:",
        "MIN_LENGTH": "obsahovat alespoň {{ minPasswordLength }} znaků",
        "UPPERCASE": "obsahovat alespoň jedno velké písmeno (A-Z)",
        "LOWERCASE": "obsahovat alespoň jedno malé písmeno (a-z)",
        "NUMBER": "obsahovat alespoň jedno číslo (0-9)",
        "SPECIAL": "obsahovat alespoň jeden speciální znak (-*/?#&())",
        "SUBMIT": "VYTVOŘIT UŽIVATELE",
        "QR_CODE": "QR kód",
        "AUTHENTICATE": "Chytré brýle a mobilní telefony můžete ověřit pomocí QR kódu.",
        "GENERATE_QR_CODE": "VYGENEROVAT QR",
        "REGENERATE_QR_CODE": "Obnovit kód",
        "DOWNLOAD": "STÁHNOUT",
        "DELETE": "VYMAZAT",
        "LIMIT-WARNING": "Uživatel bude vytvořen, ale nebude licencovaným uživatelem workflow, protože jste již dosáhli svého limitu.",
        "DELETE-USER-OR-NOT": "Opravdu chcete tohoto uživatele smazat?",
        "DELETE-QR-OR-NOT": "Opravdu chcete tento QR kód smazat?",
        "CREATED-SUCCESSFULLY": "Uživatel byl úspěšně vytvořen. Ale váš limit uživatelů pracovního postupu je plný. Tento uživatel není uživatelem pracovního postupu",
        "ROLE": "Role",
        "EDITOR-ACCESS": "Přístup editoru",
        "EDITOR-ACCESS-TEXT": "Uživateli bude udělen přístup k editoru, aby mohl vytvářet a upravovat pracovní postupy."
      },
      "USER-LIST": {
        "TITLE": "Uživatelé",
        "CREATE": "VYTVOŘIT UŽIVATELE",
        "SIMPLIFY": "Chtěli byste vědět, jak si zjednodušit pracovní procesy, eliminovat papírování a snížit administrativní zátěž? Naše softwarové řešení je jednotné, jediné softwarové řešení pro řízení pracovních procesů, které sníží složitost řízení lidských zdrojů a pracovních procesů. Toto softwarové řešení lze přizpůsobit vašim specifickým potřebám a jedná se o škálovatelnou technologii.",
        "LICENSED": "Uživatelé licencovaného workflow:",
        "SEARCH": "Hledat",
        "UNLIMITED": "Neomezený",
        "LIST": {
          "WORKFLOW-USER": "Uživatel workflow",
          "NAME": "název",
          "USERNAME": "Uživatelské jméno"
        },
        "ACTIONS": {
          "OPTIONS": "Možnosti",
          "EDIT": "Upravit",
          "DELETE": "Vymazat"
        },
        "LICENCE-LIMIT": "Váš účet dosáhl maximálního počtu odeslání pracovního postupu. Aktualizujte prosím svou licenci, abyste viděli nejnovější odeslané pracovní postupy.",
        "DEACTIVATE": {
          "DEACTIVATED": "uživatel deaktivován",
          "SAVE": "Uložit",
          "CANCEL": "zrušení"
        },
        "CHANGES-WARNING": "Existují neuložené změny. Opravdu chcete zavřít?",
        "DELETE-OR-NOT": "Opravdu chcete tohoto uživatele smazat?",
        "SAVE-SUCCESSFUL": "Uložit úspěšně",
        "LIMIT-EXCEED":"Překročení limitu.",
        "ERROR": "Chyba",
        "USERS-AND-TEAMS": "Uživatelé a týmy",
        "TEAMS": "Týmy",
        "CREATE-TEAM": "VYTVOŘTE TÝM",
        "TEAM": "Tým"
      },
      "WORKFLOW": {
        "REQUIRED": "Povinné pole",
        "SIDEBAR": {
          "DETAILS": "Podrobnosti",
          "EDITOR": "Editor",
          "CONNECTIONS": "Vazby"
        },
        "WORKFLOW-DETAIL": {
          "TITLE": "Podrobnosti",
          "NAME": {
            "TITLE": "název",
            "REQUIRED": "Povinné",
            "NO-NAME": "Toto pole je povinné"
          },
          "DESCRIPTION": "Popis",
          "DURATION": "Odhadovaná doba trvání",
          "LABEL": {
            "TITLE": "Štítky",
            "CREATE": "Vytvořit nový",
            "NO-ITEMS-FOUND": "Nebyly nalezeny žádné položky"
          },
          "SHOW-CONTENT-PAGE": "Zobrazit stránku s obsahem",
          "UPLOAD-FILE": "Nahrát soubor",
          "PREVIEW-TEXT": "Chcete-li upravit workflow, přejděte na kartu Editor.",
          "UPLOAD-FILE-INFO": "Můžete nahrát soubory obsahující informace o tomto workflow. V současné době jsou podporovány pouze soubory pdf.",
          "CONNECTION-WARNING": "„Stránka s obsahem“ nemůže být povolena, protože jsou aktivované vazby.",
          "DELETE-FILE": "Opravdu chcete tento soubor smazat?"
        },
        "WORKFLOW-STEPS": {
          "STEP-LIST": {
            "INFORM": "Vytvořte nový krok pomocí tlačítka níže",
            "STEP": {
              "NO-NAME": "Název kroku je povinný.",
              "OPTIONS": {
                "RENAME": "Přejmenovat",
                "DUPLICATE": "Duplikovat",
                "DELETE": "Vymazat",
                "MOVE": "Přesunout",
                "CLONE": "Kopírovat",
                "CLONE-STEP": "Zkopírovat krok",
                "MOVE-STEP": "Přesunout krok"
              },
              "CREATE": "Vytvořit nový krok",
              "ADD-STEP": "Přidat krok"
            },
            "TEXT-MESSAGE": "Vaše změny budou odstraněny. Chcete smazat kroky, které jste přidali?",
            "CLONE-TEXT-MESSAGE": "Krok, který jste vybrali, se zkopíruje do vybraného workflow.",
            "MOVE-TEXT-MESSAGE": "Krok, který jste vybrali, se přesune do vybraného workflow a bude z tohoto workflow odstraněn.",
            "SELECT": "Vybrat",
            "CREATE-SECTION": "Vytvořit sekci",
            "SECTION-TEXT-MESSAGE": "V tomto workflow není žádná sekce. Po vytvoření sekce do ní budou přidány dříve vytvořené kroky. Chceš pokračovat?",
            "SECTION-DELETE-TEXT-MESSAGE": "Tato sekce a kroky v ní budou odstraněny. Pokud kroky nechcete smazat, můžete je před smazáním přesunout.",
            "INDEPENDENT": "Kroky nemohou být nezávislé na sekci",
            "DELETE-STEP": "Vybrané kroky budou smazány. Opravdu chcete smazat níže uvedené kroky?",
            "INITIAL-STEP-WARNING-MESSAGE": "Vybraný krok je počátečním krokem pracovního postupu. Před vymazáním musíte změnit počáteční krok.",
            "CONNECTED-STEPS-WARNING-MESSAGE": "S těmito kroky jsou spojeny kroky. Pokud tento krok odstraníte, vaše připojení zmizí. Zkontrolujte prosím svá připojení na stránce připojení."
          },
          "STEP-PREVIEW": {
            "NO-STEP": "Nevybraný"
          },
          "WIDGET-PROPERTIES": {
            "EMPTY": "Kliknutím sem přidáte obsah.",
            "INFORM": "Na náhledu kroku můžete vidět, jak se váš obsah zobrazí uživateli.",
            "BACK": "Zpět",
            "POSITION": {
              "TITLE": "Pozice",
              "HORIZONTAL": "Horizontální pozice",
              "VERTICAL": "Vertikální poloha"
            },
            "LABEL": {
              "TITLE": "Nadpis",
              "REQUIRED": "Povinné",
              "NO-LABEL": "Štítek je povinný."
            },
            "PLACEHOLDER": "Zástupný symbol",
            "OPTIONS": {
              "TITLE": "Možnosti",
              "NO-LABEL": "Štítek je povinný.",
              "MUST-UNIQUE": "Štítky možností musí být jedinečné.",
              "DELETE-LAST": "- Poslední položku nelze smazat",
              "ADD": "Přidat možnost",
              "MAX-ADDED": "Přidání velkého množství prvků může vyžadovat rolování na chytrých brýlích."
            },
            "NUMBER-FIELDS": {
              "MIN": "Min",
              "MAX": "Max",
              "UNIT": "Jednotka",
              "PRECISION": "Přesnost"
            },
            "PPE-FIELDS": {
              "TITLE": "Zjistěte následující zařízení:",
              "FACE": "Obličejový kryt",
              "HEAD": "Pokrývka hlavy",
              "HAND": "Zakrytí rukou",
              "NO-RECOGNITION": "Vyberte alespoň jedno rozpoznání OOP."
            },
            "TIME-PICKER": "Datum zahrnuje čas",
            "QR-FIELD": "Hodnota QR kódu",
            "QR-ACTIVATION": "Aktivujte ověření QR",
            "QR-FIELD-VALIDATION-TEXT": "Pole QR je povinné.",
            "QR-ACTIVATION-INFO-TEXT": "Když je povoleno ověření QR, bude vámi poskytnutá hodnota QR kódu (odkaz QR) porovnána s QR kódem naskenovaným uživatelem, aby se zjistilo, zda se shodují.",
            "REQUIRED": {
              "TEXT": "Nastavte toto pole jako povinné",
              "INFORM": "Aktivujte toto tlačítko, pokud se chcete ujistit, že tento krok nemůže uživatel přeskočit."
            },
            "IMAGE": {
              "TITLE": "Nahrát obrázek",
              "REQUIRED": "Povinné",
              "UPLOAD": {
                "DRAG-DROP": "Drag & Drop",
                "INFORM": "Přetáhněte soubory nebo klikněte na tlačítko pro nahrání",
                "CLICK": {
                  "UPLOAD": "Nahrát obrázek",
                  "CHANGE": "Změnit obrázek",
                  "EDIT": "Upravit obrázek"
                }
              },
              "NO-IMAGE": "Obrázek je povinný."
            },
            "GALLERY": {
              "TITLE": "Nahrát obrázky",
              "REQUIRED": "Povinné",
              "NO-IMAGE": "Obrázek je povinný",
              "DELETE-IMAGE-TEXT-MESSAGE": "Opravdu chcete tento obrázek smazat?",
              "VALIDATION-TEXT": "Můžete nahrát až 50 obrázků.",
              "DELETE-IMAGE": "Smazat obrázek"
            },
            "VIDEO": {
              "TITLE": "Nahrajte video",
              "REQUIRED": "Povinné",
              "UPLOAD": {
                "DRAG-DROP": "Drag & Drop",
                "INFORM": "Přetáhněte soubory nebo je nahrajte kliknutím sem",
                "CLICK": {
                  "UPLOAD": "Nahrajte video",
                  "CHANGE": "Změnit video"
                }
              },
              "NO-IMAGE": "Video je povinné."
            },
            "PDF": {
              "TITLE": "Nahrát PDF",
              "REQUIRED": "Povinné",
              "UPLOAD": {
                "DRAG-DROP": "Drag & Drop",
                "INFORM": "Přetáhněte soubory nebo je nahrajte kliknutím sem",
                "CLICK": {
                  "UPLOAD": "Nahrát PDF",
                  "CHANGE": "Změnit PDF"
                }
              },
              "NO-IMAGE": "PDF je povinné"
            },
            "TABLE": {
              "CREATE-TABLE": "Vytvořit tabulku",
              "COLUMN": "Sloupec",
              "ROW": "Řádek",
              "CREATE": "Vytvořit",
              "ADD-ROW": "Přidat řádek",
              "DELETE-ROW": "Smazat řádek",
              "ADD-COLUMN": "Přidat sloupec",
              "DELETE-COLUMN": "Smazat sloupec",
              "SELECT-CELL-TEXT": "Chcete-li vyplnit tabulku, vyberte buňku",
              "SELECT-CONTENT-TYPE-TEXT": "Vyberte typ obsahu"
          },
            "TEXT-MESSAGE": "Opravdu chcete widget nahradit?",
            "DELETE-TEXT-MESSAGE": "Opravdu chcete widget smazat?",
            "TITLE-DELETE": "Smazat widget",
            "TITLE-CHANGE": "Vyměňte widget",
            "REPLACE": "Vyměňte",
            "DELETE-ROW-TEXT-MESSAGE": "Opravdu chcete smazat řádek?",
            "DELETE-COLUMN-TEXT-MESSAGE": "Opravdu chcete sloupec smazat?",
            "TITLE-DELETE-ROW": "Smazat řádek",
            "TITLE-DELETE-COLUMN": "Smazat sloupec",
            "CONNECTION-WARNING-TEXT-MESSAGE": "Tento widget nemůžete změnit. Protože a je to spojen s podmínkou.",
            "CONNECTION-WARNING-HEADER": "Upozornění na připojení",
            "WIDGET-TITLES": {
              "LABEL": "Štítek",
              "TEXT-INPUT": "Textový vstup",
              "NUMBER-INPUT": "Zadání čísla",
              "DATE-PICKER": "Výběr data",
              "CHECKBOX": "Zaškrtávací políčko",
              "RADIO-BUTTON": "Přepínač",
              "IMAGE": "Obrázek",
              "VIDEO": "Video",
              "PDF": "PDF",
              "DETECT-QR": "Detekce QR",
              "CAPTURE-IMAGE": "Zachytit obrázek",
              "CAPTURE-VIDEO": "Natočit video",
              "PPE": "OOP",
              "VOICE-RECORD": "Hlasový záznam",
              "VOICE": "Hlas",
              "VSIGHT-REMOTE": "VSight Remote",
              "AR-INSTRUCTION": "AR instrukce",
              "HTML": "Bohatý text",
              "GALLERY": "Galerie",
              "TABLE": "Stůl",
              "FORM": "Formulář",
              "WORKFLOW": "Workflow",
              "ID": "ID",
              "SIGNATURE": "Podpis"
            },
            "WIDGET-DESCRIPTION": {
              "INSTRUCTION": "Návod",
              "FEEDBACK": "Zpětná vazba",
              "VISUAL-SUPPORT": "Vizuální podpora",
              "AUGMENTED-REALITY": "Rozšířená realita",
              "VISUAL-AI": "Vizuální AI",
              "COMING-SOON": "Již brzy",
              "FULLSCREEN": "Dostupné pouze na celé stránce"
            },
            "LIMIT-EXCEED": "Překročení limitu. Maximální limit je 50."
          },
          "STEP-FILES": {
            "TITLE": "Krokové soubory",
            "VIEW-STEP-FILES": "Zobrazit Step Files"
        }
        },
        "TITLE": "Workflow",
        "APPROVE": "Schválit",
        "CANCEL": "Zrušit",
        "SAVE": "Uložit koncept",
        "PUBLISH": "PUBLIKOVAT",
        "SAVE-PUBLISH": "Uložit a publikovat",
        "EDIT-WORKFLOW": "UPRAVIT WORKFLOW",
        "EDIT-WORKFLOW-TITLE": "UPRAVIT WORKFLOW",
        "EDIT-MODE-TEXT-MESSAGE": "Nyní jste v režimu zobrazení. Klikněte na tlačítko 'UPRAVIT PRACOVNÍ POSTUP' pro provedení změn.",
        "STEP-PREVIEW": "Náhled kroku",
        "WIDGET-PROPERTIES": "Chcete-li přidat widgety, vyberte rozvržení z náhledu kroku.",
        "CONNECTIONS-PAGE": "Stránka vazeb",
        "CHANGE-STEP-LAYOUT": "Změnit rozložení kroků",
        "ERROR-MESSAGE": {
          "MESSAGE": "Do režimu celé stránky nelze přepnout, pokud není jedna strana rozvržení prázdná.",
          "NOT-SUPPORT": "Tento widget není ve vybraném rozvržení podporován.",
          "CONFIRM": "Zavřít"
        },
        "TEXT-MESSAGE": {
          "MESSAGE": "Opravdu chcete zavřít editor? Neuložené změny budou ztraceny.",
          "CONFIRM": "Zavřít",
          "OK": "OK"
        },
        "PREVIEW": {
          "DETECT-QR": "Detekce QR kódu/čárového kódu",
          "DETECT-PPE": "Detekce OOP z kamery",
          "PICK_IMAGE": "Vyberte obrázek",
          "PICK-VIDEO": "Vyberte video",
          "CAPTURE-VIDEO": "Natočte video",
          "CAPTURE-IMAGE": "Vytvořte obrázek",
          "DETECT-PPE-FROM-FINDER": "Vyberte obrázek PPE",
          "DETECT-QR-WITH-UPLOAD": "Vyberte QR kód/čárový kód",
          "DETECT-QR-WITH-CAMERA": "Detekovat QR kód/čárový kód",
          "SIGN-HERE": "Podepište se zde"
        },
        "WORKFLOW-CONNECTIONS": {
          "CONDITIONS": "Podmínky",
          "ADD-CONDITION": "Přidat podmínku",
          "INFORM-TEXT": "Měli byste vybrat krok pro přidání podmínky.",
          "FROM": "Od",
          "TO": "Na",
          "DELETE-CONNECTION": "Smazat vazbu",
          "WHEN": "Když",
          "REQUIRED-FIELD": "Povinné pole",
          "ADD-LOGICAL-CONDITION": "Přidat logickou podmínku",
          "DELETE-CONDITION": "Smazat podmínku",
          "CONDITION": "Stav",
          "GO-TO": "Jít do",
          "ELSE-CONDITION-TEXT": "Pokud neplatí žádné podmínky, přejděte na",
          "NOT-SELECTED": "Nevybraný",
          "TURN-ON-CONNECTIONS": "zapnout vazby",
          "TURN-ON-CONNECTIONS-TEXT": "Chcete-li vytvořit podmíněný tok a upravit vazby mezi kroky, můžete zapnout kartu vazeb.",
          "SELECT": "Vybrat",
          "ENTER": "Vstoupit",
          "CONTENT-PAGE-WARNING-TEXT": "Opravdu chcete zapnout vazby?",
          "CONTENT-PAGE-IMPORTANT-WARNING-TEXT": "UPOZORNĚNÍ: Zapnutím vazeb trvale zakážete funkci „Stránka obsahu“ v tomto workflow.",
          "CONFIRM": "Ano",
          "INITIAL-STEP-CHANGE-TEXT": "Počáteční krok můžete upravit kliknutím sem",
          "INITIAL-STEP-CHANGE-WARNING-TEXT": "Tento krok nemůže být počátečním krokem, protože existují kroky, které jsou spojeny se zvoleným krokem.",
          "INVALID-DATA": "Tento krok nelze automaticky uložit z důvodu neplatných dat.",
          "ALREADY-CONNECTED": "Nelze vytvořit spojení mezi již připojenými kroky."
        },
        "HEADER-TITLES": {
          "CLOSE-WORKFLOW": "Zavřete workflow",
          "PUBLISH-WORKFLOW": "Publikovat workflow",
          "DELETE-USER": "Smazat uživatele",
          "DELETE-WORKFLOW": "Smazat workflow",
          "WARNING": "Varování",
          "DELETE-FILE": "Smazat soubor",
          "DELETE-SECTION": "Smazat sekci",
          "DELETE-STEP": "Smazat krok",
          "LOGOUT": "Odhlásit se",
          "LICENCE-WARNING": "Upozornění na licenci",
          "DUPLICATE-WORKFLOW": "Duplikovat workflow",
          "SELECT-DEFAULT-LANGUAGE": "Vyberte Výchozí jazyk"
        },
        "LANGUAGE": {
          "SEARCH": "Vyhledat",
          "ADDED": "Přidáno",
          "DEFAULT": "Výchozí",
          "NOT-ADDED": "Nepřidáno",
          "LANGUAGE-INFO-TEXT": "Vytvořte pro své uživatele vícejazyčný workflow přidáním nového jazyka. Můžete také změnit primární jazyk, ve kterém uživatelé upřednostňují zobrazení pracovního postupu tak, že jej nastavíte jako výchozí jazyk.",
          "SELECT-LANGUAGE": "Zvolte jazyk",
          "CHECK-LANGUAGE": "Po automatickém překladu jste provedli změny. Prosím, nezapomeňte zkontrolovat všechny jazyky!",
          "DELETE-LANGUAGE-OR-NOT": "Opravdu chcete smazat jazyk? Veškerý obsah ve vybraném jazyce bude ztracen."
        },
        "DELETE": "Vymazat",
        "WORKFLOW-NOT-FOUND": "Nebyl nalezen pracovní postup spojený s odkazem",
        "SAVE-SUCCESSFUL": "Uložit je úspěšné",
        "SAVE-ERROR": "Chyba uložení",
        "CLONED": "Úspěšně klonováno"
      },
      "EASY-ACCESS": {
        "MANAGE-PUBLIC-ACCESS": "Správa veřejného přístupu",
        "MANAGE-PUBLIC-ACCESS-TEXT": "Sdílení tohoto pracovního postupu můžete ukončit smazáním veřejného přístupu.",
        "GENEATE-ACCESS-TEXT": "Můžete vygenerovat veřejný odkaz a QR kód a vytvořit tak snadný přístup k tomuto pracovnímu postupu.",
        "ENABLE-PASSWORD": "Povolit heslo",
        "GENERATE-ACCESS": "Generujte snadný přístup",
        "LINK": "Odkaz",
        "COPY": "kopírovat",
        "QR-CODE": "QR kód",
        "DOWNLOAD": "Stáhnout",
        "SECURITY": "Bezpečnost",
        "PASSWORD-PROTECTED": "Chráněno heslem",
        "PUBLIC": "Veřejnost",
        "DELETE-ACCESS": "Smazat veřejný přístup",
        "EASY-ACCESS-TITLE": "Snadný přístup k pracovnímu postupu {{ shortName }}",
        "OPEN-WORKFLOW-NAME": "Chystáte se otevřít",
        "GUEST-EMAIL": "E-mail hosta",
        "REQUIRED": "Toto pole je povinné",
        "GUEST-PASSWORD": "Heslo pro hosta",
        "OPEN": "OTEVŘENO",
        "OPEN-APP": "Pro lepší práci můžete tento workflow otevřít v aplikaci.",
        "COPY-LINK-TEXT": "Zkopírujte odkaz do schránky a otevřete tento pracovní postup při spuštění aplikace.",
        "DOWNLOAD-APP": "STÁHNOUT APLIKACI",
        "OR": "NEBO",
        "CONTINUE-WITH-BROWSER": "Pokračujte v prohlížeči",
        "PASSWORD-PROTECTED-TEXT": "Když je heslo povoleno, uživatelé, kteří mají veřejný odkaz nebo QR kód, budou mít přístup k workflow pouze po zadání hesla.",
        "CREATE-PASSWORD": "Vytvořit heslo",
        "ENTER-EMAIL": "Vložte svůj e-mail",
        "ENTER-WORKFLOW-PASSWORD": "Zadejte heslo pracovního postupu",
        "DELETE-QR-TEXT": "Chcete-li změnit typ zabezpečení Snadný přístup, měli byste odstranit Snadný přístup a vygenerovat znovu.",
        "LOADING-WORKFLOW": "Načítání pracovního postupu...",
        "UNABLE-TO-LOAD": "Nelze načíst pracovní postup",
        "RETRY": "Zkusit znovu",
        "GUEST-ACCESS": {
          "TOKEN-MISSING": "Token chybí nebo je neplatný",
          "ID-MISSING": "Chybí ID pracovního postupu nebo základní adresa URL",
          "WORKFLOW-NOT-PUBLISHED": "Pracovní postup není zveřejněn",
          "PUBLIC-ACCESS": "Veřejný přístup již existuje",
          "NO-PUBLIC-ACCESS": "Žádný veřejný přístup"
        } ,
        "QR-INFORMATION": "QR informace"
      } ,
      "WORK-ORDERS": {
        "TITLE": "Work Orders",
        "CREATE-WORK-ORDER": "Create Work Order",
        "EDIT-WORK-ORDER": "Edit Work Order",
        "EDIT": "Upravit",
        "CREATE": "Vytvořit",
        "DELETE": "Vymazat",
        "SAVE-CHANGES": "Uložit změny",
        "TO-DO": "Dělat",
        "DONE": "Hotovo",
        "EMPTY-LIST": "Nebyly nalezeny žádné pracovní příkazy.",
        "PRIORITY": {
            "high": "Vysoký",
            "medium": "Střední",
            "low": "Nízký"
        },
        "STATUS": {
            "open": "OTEVŘENO",
            "in-progress": "Probíhá",
            "on-hold": "Pozastaveno",
            "done": "Hotovo"
        },
        "SELECT-DUE-DATE": "Datum splatnosti",
        "SELECT-RECURRENCE": "Opakování",
        "NO-ITEMS-FOUND": "Nebyly nalezeny žádné položky",
        "RECURRENCE": {
            "none": "Žádné",
            "daily": "Denně",
            "weekly": "Týdně",
            "monthly": "Měsíčně"
        },
        "ITEMS": {
            "ID": "ID",
            "PRIORITY": "Přednost",
            "DUE-DATE": "Datum splatnosti",
            "TASK-NAME": "Název úkolu",
            "STATUS": "Postavení",
            "ADD-DUE-TIME": "Přidejte čas",
            "CLEAR-DUE-TIME": "Jasný čas",
            "RECURRENCE": "Opakování",
            "DESCRIPTION": "Popis",
            "FILES": "Soubory",
            "ASSIGNED-WORKFLOWS": "Přiřazeno Workflow",
            "ADD-WORKFLOW": "Přidej workflow",
            "ASSIGNED-TO": "Přiřazen",
            "SELECT-USER": "Vyberte uživatele",
            "ACTIVITY": "Aktivita"
        },
        "WARNING": {
            "DELETE-WORK-ORDER-TITLE": "Delete Work Order",
            "DELETE-WORK-ORDER-TEXT": "Are you sure you want to delete this work order?"
        }
    },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Video toky",
                "CREATE-VIDEO-FLOW": "Vytvořit video tok",
                "CREATED-BY-AI": "Vytvořeno umělou inteligencí",
                "VERSION": "Verze",
                "NO-VIDEO-FLOWS-FOUND": "Nebyly nalezeny žádné video toky",
                "CLEAR-ALL": "Vymazat vše",
                "CONFIRM-VIDEO": "Potvrdit video",
                "CONFIRM-VIDEO-TITLE": "Potvrdit konverzi videa",
                "CONFIRM-VIDEO-MESSAGE": "Opravdu chcete převést tento video tok na workflow? Po potvrzení nebudete moci video upravovat.",
                "CONFIRM-VIDEO-BUTTON": "Potvrdit a převést",
                "MAKE-WORKFLOW-SUCCESSFUL": "Úspěšně převedeno na workflow",
                "MAKE-WORKFLOW-ERROR": "Nepodařilo se převést na workflow",
                "UPLOAD-VIDEO-DESCRIPTION": "Nahrajte své video a automaticky vygenerujte průvodce workflow krok za krokem.",
                "VIDEO-DURATION-LIMIT": "Délka videa nesmí překročit 30 minut.",
                "VIDEO-UPLOADED-SUCCESS": "Video bylo úspěšně nahráno!",
                "SELECT-VIDEO": "Vybrat video",
                "CHANGE-VIDEO": "Změnit video",
                "CREATE-BUTTON": "Vytvořit",
                "AI-PROCESSING": "Probíhá zpracování AI",
                "SPLITTING-VIDEO": "Rozdělení videa na segmenty",
                "TRANSCRIBING-VIDEO": "Přepisování obsahu videa",
                "PROCESS-WARNING": "Tento proces může trvat až 10 minut. Nezavírejte prosím toto okno."
            }
    },
    "NAVBAR": {
      "LOGOUT": {
        "TEXT": "Odhlásit se",
        "TEXT-MESSAGE": {
          "MESSAGE": "Opravdu se chcete odhlásit?",
          "CONFIRM": "Odhlásit se"
        }
      }
    },
    "SIDEBAR": {
      "WORKFLOWS": "Workflows",
      "USERS": "Uživatelé",
      "REPORTS": "Hlášení",
      "DRAFTS": "Hlášení",
      "SWITCH-ADMIN-PANEL": "Přepněte do Editoru",
      "SWITCH-USER-PANEL": "Prepnúť na Editor",
      "SWITCH-ADMIN-PANEL-TEXT": "Chcete-li vytvářet a upravovat pracovní postupy, přepněte z panelu Uživatel na Editor.",
      "SWITCH-USER-PANEL-TEXT": "Chcete-li dokončit pracovní postupy, přepněte z Editoru na panel Uživatel."
    },
    "USER-WORKFLOW": {
      "ADD": "PŘIDAT",
      "INVALID-EMAIL": "Odesílání e-mailem",
      "SEND-REQUEST": "Odeslat ke schválení:",
      "REMOVE": "VYMAZAT",
      "APPROVAL-REQUEST": "Žádost o schválení",
      "REQUEST-SENDED-TEXT": "Vaše žádost o schválení byla úspěšně odeslána na uvedené e-mailové adresy.",
      "CLOSE": "ZAVŘÍT",
      "LICENCE-LIMIT": "Váš účet dosáhl maximálního počtu odeslání pracovního postupu. Správce účtu uvidí zprávu po upgradu licence.",
      "REQUEST-PENDING": "Žádost o schválení čeká na vyřízení",
      "REQUEST-APPROVAL": "RŽádost o schválení zprávy",
      "SEND-REQUEST-TITLE": "POSLAT ŽÁDOST",
      "TASK-TO-COMPLETE": "Úkol k dokončení:",
      "SELECT-LANGUAGE": "Zvolte jazyk",
      "CONTENT-LANGUAGE": "Jazyk obsahu:",
      "ESTIMATED-DURATION": "Odhadovaná doba trvání:",
      "DELETE": "Vymazat",
      "DELETE-APPROVAL": "Jste si jistí, že to chcete smazat?",
      "EMAIL-INVALID": "Formát e-mailu je neplatný",
      "MISSING-EQUIPMENT": "Chybějící vybavení",
      "PROTECTED-EQUIPMENT": "Používejte prosím povinné osobní ochranné prostředky",
      "CONTINUE-WITH-QR-WARNING-TEXT": "Chystáte se předat svůj pracovní postup jako předvyplněný. Bude vygenerován odkaz a QR kód pro předvyplněný pracovní postup, ke kterému budete mít přístup a bude pokračovat později. Po vygenerování QR kódu nelze předvyplněné kroky upravovat. Opravdu chcete pokračovat?",
      "CONTINUE-WITH-QR-TITLE": "PŘEDEJTE PŘEDPLNĚNÝ PRACOVNÍ POSTUP",
      "TABLE-OF-CONTENTS": "Obsah",
      "CALL-EXPERT": "Zavolejte expertovi",
      "HAND-OVER": "Předat",
      "CANCEL": "ZRUŠENÍ",
      "CALL": "VOLÁNÍ",
      "SAVE-CHANGES": "Uložit změny",
      "CALL-PERMISSION-WARNING": "Nemáte oprávnění zavolat odborníka. Obraťte se na správce systému.",
      "SELECT-EXPERT-TEXT": "Vyberte odborníka, kterému chcete zavolat:",
      "ERRORS": {
        "INTEGRATION-NOT-FOUND": "Integrace nenalezena"
      },
      "QR-NOT-MATCHED": "QR kód se neshoduje",
      "STEP-FILES": {
        "TITLE": "KROKOVÉ SOUBORY"
    }
    },
    "LOBBY": {
      "LOBBY_SHARED": {
          "ONGOING_CALLS_TITLE": "Probíhající hovory",
          "ROOMS_TITLE": "Vaše místnosti",
          "UPCOMING_MEETINGS_TITLE": "Nadcházející schůzky",
          "PREVIOUS_MEETINGS_TITLE": "Předchozí schůzky",
          "SCHEDULE_MEETING": "Naplánujte schůzku",
          "INSTANT_GUEST_ACCESS": "Okamžitý přístup pro hosty",
          "INSTANT_GUEST_ACCESS_NO_CALLING": "Nemáte oprávnění k uskutečňování hovorů. Kontaktujte prosím svého administrátora.",
          "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Nemáte oprávnění vytvořit odkaz pro přístup pro hosty. Kontaktujte prosím svého administrátora.",
          "INSTANT_GUEST_ACCESS_NO_PERM": "Nemáte oprávnění uskutečňovat hovory ani vytvářet odkazy pro přístup pro hosty. Kontaktujte prosím svého administrátora.",
          "LINK_UNAVAILABLE": "Odkaz není k dispozici",
          "JOIN": "PŘIPOJIT",
          "CANCEL": "ZRUŠIT",
          "REMOVE": "ODSTRANIT",
          "NO_ROOM": "Nemáte žádné místnosti",
          "NO_MEETING": "Nemáte žádnou schůzku.",
          "NO_PREV_MEETING": "Nemáte žádnou schůzku.",
          "NO_OTHER_USERS": "Žádní další uživatelé",
          "SHOW_MORE": "zobrazit další {{ count }}",
          "SHOW_LESS": "zobrazit méně"
      },
      "SCHEDULE_MEETING_MODAL": {
          "TITLE": "Naplánovat schůzku",
          "MEETING_TITLE": "Název",
          "MEETING_TITLE_REQUIRED": "Název je povinný",
          "START_DATE": "Start",
          "END_DATE": "Konec",
          "CLOSE": "Zavřít",
          "SCHEDULE_SEND": "Naplánovat a odeslat",
          "SCHEDULE": "Plán",
          "CANNOT_SCHEDULE": "Při plánování schůzky došlo k chybě.",
          "CANNOT_CANCEL_MEETING": "Při rušení schůzky došlo k chybě.",
          "ENTER_USERS": "Zadejte uživatele",
          "SEND_INVITATIONS": "Poslat pozvánky",
          "INVITATION_EMAIL_LANG": "Jazyk e-mailu s pozvánkou",
          "SHARE_AFTER": "Odkaz na schůzku lze sdílet i po naplánování."
      },
      "CANCEL_MEETING_MODAL": {
          "CANCEL_TITLE": "Zrušit schůzku",
          "REMOVE_TITLE": "Smazat schůzku",
          "CANCEL_MESSAGE": "Opravdu chcete schůzku zrušit?",
          "REMOVE_MESSAGE": "Opravdu chcete schůzku smazat?",
          "CLOSE": "Zavřít",
          "PROCEED": "Pokračovat"
      },
      "CONTACTS": {
          "TITLE": "Uživatelé",
          "NO_PERMISSION": "Nemáte oprávnění k zobrazení seznamu uživatelů a hovorů.",
          "NO_CONTACT": "Seznam uživatelů je prázdný.",
          "SELECT_MULTI": "Vybrat více",
          "CALL": "Hovor",
          "ADMIN": "Administrátor",
          "COADMIN": "Spoluadministrátor",
          "EXPERT": "Expert",
          "SUBSCRIBER": "Odběratel",
          "USER": "Uživatel",
          "NAME": "Jméno",
          "USERNAME": "Uživatelské jméno",
          "ROLE": "Role",
          "NO_EXPERT": "Vyberte prosím alespoň jednoho experta, kterému chcete zavolat.",
          "NAME_USERNAME": "Jméno nebo Uživatelské jméno",
          "ALL_ROLES": "Všechny role"
      },
      "SESSIONS": {
          "TITLE": "Relace",
          "DATE": "Vytvořeno dne",
          "DURATION": "Doba trvání",
          "ROOM_NAME": "Místnost",
          "NO_SESSIONS": "Seznam relací je prázdný.",
          "PARTICIPANTS": "Účastníci",
          "EXPORT": "Vývozní",
          "STATUS": "Stav",
          "ON_GOING": "Pokračující",
          "ENDED": "Skončilo",
          "FILES": "Soubory",
          "CHAT": "Povídat si",
          "SESSION_FILES": {
              "MULTIPLE_SELECTION": "Vybrat více",
              "DOWNLOAD": "Stažení",
              "DOWNLOAD_STARTED_SOON": "Stahování bude brzy zahájeno.",
              "DOWNLOAD_FAILED": "Stažení se nezdařilo.",
              "NO_FILE_IS_ADDED": "V této relaci není přidán žádný soubor ani s ním nespolupracuje.",
              "SUCCESS_MESSAGE": "Soubory byly úspěšně staženy."
          },
          "ATTACHED_TICKET": "Přiložený tiket",
          "SESSION_DETAILS": "Podrobnosti relace",
          "BACK": "Zpět",
          "GET_SESSION_EXPORT": "Získejte export relace",
          "ATTACH_TO_TICKET": "Připojit k tiketu"
      },
      "TICKETS": {
          "TITLE": "Vstupenky",
          "NEW_TICKET": "Nový tiket",
          "ALL_ROOMS": "Všechny místnosti",
          "ALL_STATUSES": "Všechny stavy",
          "NO_TICKETS": "Seznam tiketů je prázdný.",
          "TICKET_TITLE": "Titul",
          "ROOM": "Název",
          "CREATED_BY": "Místnost",
          "CREATED_ON": "Vytvořeno dne",
          "STATUS": "Postavení",
          "STATUS_OPEN": "Stav",
          "STATUS_IN_PROGRESS": "Probíhá",
          "STATUS_CLOSED": "ZAVŘENO",
          "CLOSE_PICK_TICKET": "ZAVŘÍT",
          "CREATE_NEW": "VYTVOŘIT NOVÝ",
          "ATTACH": "PŘIPOJIT",
          "CREATE_TICKET": "Vytvořit tiket",
          "TICKET_DETAILS": "Podrobnosti tiketu",
          "EDIT": "UPRAVIT",
          "TICKET_TYPE": "Typ tiketu",
          "ROOM2": "Místnost:",
          "CREATED_BY2": "Vytvořil:",
          "CREATED_ON2": "Vytvořeno dne:",
          "ROOM3": "Místnost",
          "STATUS2": "Stav",
          "PRIORITY": "Přednost",
          "ASSIGNEE": "Zřizovatel",
          "FOLLOW_UP": "Navazující datum",
          "TICKET_TITLE2": "Název",
          "TITLE_REQUIRED": "Název je povinný",
          "DESCRIPTION": "Popis",
          "DESCRIPTION_REQUIRED": "Popis je povinný",
          "RESOLUTION": "Rozlišení",
          "ATTACHED_SESSIONS": "PŘIPOJIT RELACI",
          "NO_ATTACHED_SESSIONS": "Seznam připojených relací je prázdný",
          "SESSION_COUNT": "Počet relací:",
          "TOTAL_DURATION": "Celková doba trvání:",
          "PARTICIPANTS2": "Účastníci:",
          "COUNT_SESSIONS": " {{count}} relací",
          "DATE": "datum",
          "ROOM_NAME": "Název místnosti",
          "PARTICIPANTS": "Účastníci",
          "DURATION": "Doba trvání",
          "GUEST": "(Host)",
          "CANCEL": "ZRUŠIT",
          "CLOSE": "ZAVŘÍT",
          "SAVE": "ULOŽIT",
          "CREATE": "VYTVOŘIT",
          "CREATED_BETWEEN": "Vytvořeno mezi",
          "ALL_CREATORS": "Všichni tvůrci",
          "SEND_VIA_EMAIL": "ODESLAT E-MAILEM",
          "DELETE_TICKET": "SMAZAT TIKET",
          "DELETE_TICKET_MODAL": {
              "TITLE": "Smazat tiket?",
              "MESSAGE": "Opravdu chcete smazat tiket <strong>{{title}}</strong>?",
              "CANCEL": "ZRUŠENÍ",
              "DELETE": "SMAZAT"
          },
          "LOW": "Nízký",
          "MEDIUM": "Střední",
          "HIGH": "Vysoký",
          "CHOOSE_TICKET": "Vyberte lístek",
          "ERRORS": {
              "TICKET_ALREADY_ATTACHED": "Vstupenka již přiložena.",
              "ERROR_OCCURED": "Došlo k chybě.",
              "PERMISSION_DENIED": "Přístup odepřen.",
              "MISSING_PARAMETERS": "Chybí parametry",
              "FILE_ALREADY_EXIST": "Soubor již existuje"
          },
          "FILES": "Soubory",
          "UPLOAD_FILE": "NAHRÁT SOUBOR"
      },
      "ARCHIVES": {
          "ARCHIVE_LIST": {
              "REFRESH": "Obnovit",
              "LOADING": "Načítání záznamů videohovorů",
              "NO_ARCHIVE_MESSAGE": "Neexistuje žádný záznam videohovoru",
              "NAME": "název",
              "CREATED_AT": "Vytvořeno v",
              "STORAGE": "Úložný prostor",
              "DURATION": "Doba trvání",
              "ARCHIVES": "Záznamy videohovorů",
              "SIZE": "Velikost souboru",
              "STATUS": "Stav",
              "AVAILABLE": "dostupný",
              "DISCONNECTED": "odpojeno",
              "DELETED": "smazáno",
              "EXPIRED": "platnost vypršela",
              "WAITING": "čekání",
              "FAILED": "nepodařilo",
              "DOWNLOAD": "Stažení",
              "PLAY": "Spustit",
              "DELETE": "Vymazat",
              "DOWNLOAD_ARCHIVE": {
                  "TITLE": "Stáhnout záznam",
                  "GENERATING": "Generování adresy URL ke stažení",
                  "GENERATED": "Vygenerována adresa URL ke stažení",
                  "CANNOT_GENERATED": "Nelze vygenerovat adresu URL ke stažení.",
                  "DOWNLOAD": "Stažení",
                  "CLOSE": "Zavřít"
              },
              "DELETE_ARCHIVE": {
                  "TITLE": "Smazat záznam",
                  "MESSAGE": "Záznam videohovoru bude smazán.",
                  "CAUTION": "UPOZORNĚNÍ: Tento záznam bude odstraněn i z vašeho úložiště Azure.",
                  "CANCEL": "Zrušit",
                  "DELETE": "Vymazat"
              }
          }
      },
      "CONVERTER": {
          "TITLE": "Konvertor",
          "STP_ONLY": "Podporovány jsou pouze formáty souborů .stp a .step.",
          "ERROR_UPLOAD": "Při nahrávání souboru došlo k chybě.",
          "DRAG": "Sem přetáhněte soubor",
          "OR": "nebo",
          "CHOOSE": "Vyberte soubor",
          "CONVERT": "Konvertovat",
          "SUPPORTED": "Podporované formáty souborů:",
          "BACK": "Zpět",
          "DOWNLOAD": "Stažení",
          "ERROR_LOAD": "Při načítání objektu došlo k chybě."
      },
      "WHATSNEW": {
          "WHATSNEW_TITLE": "Co je nového",
          "NO_UNREAD_UPDATE": "Žádná nepřečtená aktualizace"
      },
      "JOIN_MODAL": {
          "JOIN": "PŘIPOJIT",
          "CALL": "HOVOR",
          "CANCEL": "ZRUŠIT",
          "MIRROR_VIDEO": "Zrcadlené video",
          "PREFERRED_RESOLUTION": "Preferované rozlišení",
          "RESOLUTION_NOTE": "Poznámka: Pokud vaše zařízení nepodporuje požadované rozlišení, použije se další největší rozlišení.",
          "CAM_MIC_PERM_REQUIRED": "Vyžadováno povolení kamery a mikrofonu",
          "CAM_MIC_PERM_DENIED": "Přístup ke kameře nebo mikrofonu odepřen",
          "CAM_MIC_CANT_ACCESS": "Nemáme přístup k vaší kameře nebo mikrofonu",
          "JOIN_CAM_OFF": "Připojte se s vypnutou kamerou",
          "JOIN_MIC_OFF": "Připojte se s vypnutým mikrofonem",
          "JOIN_CAM_MIC_OFF": "Připojte se s vypnutou kamerou a mikrofonem",
          "JOIN_NO_DEVICE": "Připojte se bez kamery a mikrofonu",
          "ALLOW_ACCESS": "V nastavení prohlížeče musíte povolit přístup ke kameře a mikrofonu (po udělení přístupu můžete kameru nebo mikrofon vypnout).",
          "TRY_AGAIN": "Zkuste to znovu/obnovte stránku a na výzvu prohlížeče vyberte „Povolit“."
      },
      "NO_DEVICE_MODAL": {
          "TITLE": "Nebylo nalezeno žádné zařízení",
          "JOIN_BODY": "K tomuto zařízení není připojen žádný mikrofon ani kamera. Ostatní uživatelé vás prostřednictvím tohoto zařízení neuslyší ani neuvidí. Chcete se ipřesto přidat?",
          "CALL_BODY": "K tomuto zařízení není připojen žádný mikrofon ani kamera. Ostatní uživatelé vás prostřednictvím tohoto zařízení neuslyší ani neuvidí. Chceteipřesto volat?",
          "CANCEL": "Zrušit",
          "JOIN": "Přesto se připojit",
          "CALL": "Přesto zavolat"
      },
      "AGREEMENT_MODAL": {
          "TITLE": "Zpracování a zabezpečování Formuláře schválení osobních dat ",
          "REJECTION_BUTTON": "Odmítnout",
          "AGREEMENT_BUTTON": "Souhlasit"
      },
      "CHECK_AGREEMENT_MODAL": {
          "TITLE": "Zrušit smlouvu?",
          "ERROR": "Došlo k chybě.",
          "STATEMENT": "Pokud smlouvu nepřijmete, nebudete se moci přihlásit do systému.",
          "CANCEL_BUTTON": "Zrušit",
          "PROCEED_BUTTON": "Pokračovat"
      },
      "JOIN_UNKNOWN_ERROR": "Při připojování k místnosti došlo k chybě.",
      "JOIN_CONCURRENT_ERROR": "Dosáhli jste limitu počtu souběžných uživatelů účtu. Další podrobnosti vám poskytne váš administrátor.",
      "JOIN_EXPERT_CONCURRENT_ERROR": "Dosáhli jste limitu počtu souběžných uživatelů pro experty. Další podrobnosti vám poskytne váš administrátor.",
      "NO_TRAINING_LICENSE": "Vyskytl se problém s licencí vaší školicí místnosti. Kontaktujte prosím svého administrátora.",
      "TRAINING_LICENSE_EXPIRED": "Licence vaší školicí místnosti vypršela. Kontaktujte prosím svého administrátora.",
      "ASK_TRAINING_HOST": "Při připojování do školicí místnosti došlo k chybě. Kontaktujte prosím hostitele.",
      "JOIN_CALL_IN_PROGRESS": "Ve vaší osobní zasedací místnosti je další hovor.",
      "NOT_SUPPORTED_TITLE": "Nekompatibilní prohlížeč",
      "NOT_SUPPORTED_MESSAGE": "Váš prohlížeč není kompatibilní. Použijte prosím Google Chrome, Mozilla Firefox, Safari nebo Microsoft Edge (verze 79 nebo novější).",
      "NO_IOS_MESSAGE": "Váš prohlížeč není kompatibilní. Použijte prosím vzdálenou aplikaci {{ appName }} nebo použijte Safari.",
      "IOS_VERSION_MESSAGE": "Váš prohlížeč není kompatibilní. Použijte prosím vzdálenou aplikaci {{ appName }}.",
      "NOT_SUPPORTED_CLOSE": "Zavřít",
      "IDLE_MODAL_TITLE": "Chyba",
      "IDLE_MODAL_MESSAGE": "Delší dobu jste neprovedli žádnou transakci.",
      "IDLE_MODAL_COUNT": "Budete odhlášeni za {{ count }} sekund.",
      "IDLE_MODAL_OK": "Jsem zpět",
      "ARCHIVE_PERMISSION_MODAL": {
          "TITLE": "Povolit nahrávání?",
          "MESSAGE": "Schůzka v této místnosti bude nahrávána. Abyste se mohli připojit k této místnosti, musíte povolit nahrávání videa.",
          "DENY": "Odmítnout",
          "ALLOW": "Povolit"
      }
  },
    "LICENCE-EXPIRED": "Vaše licence vypršela"
  },
  "MODALS": {
      "ALERT": {
        "TEXT": "Jsi si jistá?",
        "CANCEL": "Zrušit",
        "CONFIRM": "Vymazat",
        "CONTINUE": "Pokračovat"
      },
      "IMAGE-EDITOR": {
        "TITLE": "Editor obrázků",
        "CANCEL": "Zrušit",
        "SAVE": "Uložit",
        "CROP": "Oříznutí"
      },
      "TEMPLATE": {
        "CREATE-STEP": "Vytvořit krok",
        "OPTIONS": {
          "TITLE": "Vyberte šablonu",
          "FULL": "Celá stránka",
          "VERTICAL": "Vertikální stránka",
          "HORIZONTAL": "Vodorovná stránka"
        },
        "CREATE": "Vytvořit",
        "CHANGE": "Změna"
      },
      "WORKFLOW-USERS": {
        "TITLE": "Uživatelé Workflow",
        "USERS": "Uživatelé",
        "SELECTED": "Vybraní uživatelé",
        "CLOSE": "Zavřít",
        "SAVE": "Uložit",
        "LIMIT-FULL": "Limit uživatelů pracovního postupu je plný"
      },
      "GENERATE-WORKFLOW": {
        "TITLE": "Vytvořte automatický workflow s umělou inteligencí",
        "PROMPT-TEXT": "Vložte zadání",
        "CONFIRM-BUTTON-TEXT": "PŘEDLOŽIT",
        "CANCEL-BUTTON-TEXT": "ZRUŠIT",
        "INVALID-WORKFLOW-ERROR": "Workflow nelze vytvořit pomocí tohoto zadání",
        "PERMISSION-DENIED": "Nemáte povolení",
        "PROMPT-REQUIRED": "Text zadání nebyl nalezen",
        "INTERNAL-ERROR": "Vyskytla se chyba"
      },
      "SIGNATURE": {
        "ADD-SIGNATURE": "Přidat podpis",
        "DRAW-SIGNATURE": "Nakreslete svůj podpis",
        "CLEAR": "Průhledná",
        "REQUIRED-NAME": "Jméno je povinné",
        "INSERT": "Vložit",
        "TYPE-SIGNATURE": "Zadejte svůj podpis",
        "USE-PHOTO": "Použijte fotografii svého podpisu"
      },
      "WORKFLOW-NEW-LANGUAGE": {
        "ADD-LANGUAGE": "Přidat jazyk",
        "NEW-LANGUAGE": "Chystáte se do pracovního postupu přidat nový jazyk. Chcete automaticky přeložit veškerý obsah z výchozího jazyka do jazyka, který přidáváte? Pokud chcete obsah přeložit sami, můžete zkopírovat veškerý výchozí obsah do nového jazyka a upravit ručně.",
        "AUTO-TRANSLATE": "Automatický překlad",
        "COPY-CONTENT": "Kopírovat obsah z výchozího nastavení"            
      },
      "DEFAULT-LANGUAGE": {
      "PRIMARY-LANGUAGE": "Jazyk, který zvolíte jako výchozí, bude primárním jazykem, ve kterém uživatelé uvidí tento pracovní postup na svých zařízeních. Vícejazyčný pracovní postup můžete vytvořit přidáním dalších jazyků do editoru po vytvoření pracovního postupu.",
      "DEFAULT-LANGUAGE": "Výchozí jazyk tohoto pracovního postupu",
      "CREATE": "VYTVOŘIT"
      },
      "USER-DEFAULT-LANGUAGE": {
        "PREFFERED-LANGUAGE": "Vyberte preferovaný jazyk, ve kterém chcete zobrazovat obsah pracovních postupů."
    },
    "TABLE-CELL": {
        "AT-LEAST": "Toto pole by mělo být alespoň {{selectedCell.templateOptions.min}}",
        "AT-MOST": "Toto pole by mělo mít maximálně {{selectedCell.templateOptions.max}}"
    },
    "OPEN-AI": {
        "DESCRIBE": "Popište pracovní postup, který chcete vytvořit"
    }
  },
  "NOT-FOUND": {
    "TEXT": "Je nám líto, požadovanou stránku nelze nalézt.",
    "INFORM": "Adresa URL může být špatně napsaná nebo stránka, kterou hledáte, již není dostupná."
  },
  "ERRORS": {
    "UPLOAD-ERROR": "Chyba nahrávání",
    "ERROR": "Vyskytla se chyba"
  },
  "WEB-VERSION": {
    "TASK-TO-COMPLETE": "Úkol k dokončení",
    "ESTIMATED-DURATION": "Odhadovaná doba trvání",
    "START": "START",
    "PREVIOUS": "Předchozí",
    "NEXT": "další",
    "SUBMIT": "Předložit",
    "SUCCESS-SUBMIT-MESSAGE": "Váš workflow byl úspěšně odeslán!",
    "SUCCESS-SAVE-MESSAGE": "Váš workflow byl úspěšně uložen!",
    "SAVE-AS-DRAFT": "Uložit jako koncept",
    "CLOSE-WORKFLOW-WARNING-TEXT": "Opravdu chcete tento workflow zavřít? Vaše změny budou odstraněny.",
    "CONTINUE-WORKFLOW-TEXT-MESSAGE": "Tento workflow jste již zahájili. Chcete pokračovat, nebo začít nový?",
    "CONTINUE": "Pokračovat",
    "START-OVER": "ZAČÍT ZNOVU",
    "INCOMPLETE": "Neúplný",
    "SUBMITTED": "Odesláno",
    "VERSION": "Verze",
    "LAST-SAVED": "Naposledy uloženo",
    "PUBLISHED-AT": "Publikováno na",
    "STATUS": "Stav",
    "SELECT": "Vybrat",
    "SEARCH": "Hledat"
  },
  "Number": "Číslo",
  "Text": "Text",
  "Multiple Choice": "Více možností",
  "Checkboxes": "Zaškrtávací políčka",
  "Date": "datum",
  "Time": "Čas",
  "File Upload": "Nahrání souboru",
  "Capture Image": "Vytvořit obrázek",
  "Capture Video": "Natočit video",
  "PPE": "OOP",
  "QR": "QR",
  "Contains": "Obsahuje",
  "Does not contain": "Neobsahuje",
  "Is empty": "Je prázdný",
  "Is not empty": "Není prázdný",
  "Equals": "Rovná se",
  "Not Equals": "Nerovná se",
  "Greater than": "Větší než",
  "Less than": "Méně než",
  "Greater or Equal": "Větší nebo rovno",
  "Less or Equal": "Menší nebo rovno",
  "Is": "Je",
  "Is not": "Není",
  "Starts with": "Začíná s",
  "Ends with": "Končí s",
  "Is before": "Je před",
  "Is after": "Je po",
  "Is between": "Je mezi",
  "Is not between": "Není mezi",
  "Is detected": "Je detekováno",
  "Is not detected": "Není detekováno",
  "input": "Textový vstup",
  "number": "Zadání čísla",
  "datepicker": "Výběr data",
  "multicheckbox": "Zaškrtávací políčko",
  "radio": "Přepínač",
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Položek na stránku:",
        "NEXT_PAGE": "Další stránka",
        "PREVIOUS_PAGE": "Předchozí stránka",
        "FIRST_PAGE": "První stránka",
        "LAST_PAGE": "Poslední stránka",
        "RANGE": "{{start}} – {{end}} z {{length}}",
        "RANGE_ZERO": "0 z {{length}}"
    }
}